const LOCAL_API_BASE = 'https://apicrm.dsx.com.co';

function normalizeBase(base?: string | null): string {
  return String(base || '').trim().replace(/\/$/, '');
}

function isLocalFrontendHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0';
}

export function getApiBase(): string {
  const envBase = normalizeBase(process.env.UMI_APP_API_URL);
  const runtimeBase =
    typeof window !== 'undefined'
      ? normalizeBase((window as any).__UMI_ENV__?.UMI_APP_API_URL)
      : '';
  const configuredBase = envBase || runtimeBase;

  if (!configuredBase) {
    throw new Error(
      'UMI_APP_API_URL no está definida en las variables de entorno. Configura correctamente tu .env.'
    );
  }
  return configuredBase;
}

export function getValidatedApiBase(): string {
  const base = normalizeBase(getApiBase());
  if (!base) return '';

  try {
    new URL(base);
    return base;
  } catch {
    return '';
  }
}
